import type { PartnerConfig } from "@/content/partners/types"

export const FASMINAS_PARTNER_SLUG = "fasminas"

export const FASMINAS_LOGO_PATH = "/partners/fasminas/logo.png"

export const fasminasPartnerConfig: PartnerConfig = {
  slug: FASMINAS_PARTNER_SLUG,
  name: "FASMINAS",
  fullName:
    "Federação dos Agentes e Servidores Públicos Municipais de Minas Gerais",
  logoPath: FASMINAS_LOGO_PATH,
  benefitMode: "next_band",
  isActive: true,
  metadata: {
    website: "https://fasminas.com.br/",
    affiliated_unions_page: "https://fasminas.com.br/sindicatos-filiados",
  },
}

export type FasminasAffiliatedUnion = {
  id: string
  acronym: string
  name: string
  region: string
  /** Quando disponível, salvar em `public/partners/fasminas/unions/{id}.png` */
  logoUrl?: string | null
}

export const fasminasPartnerContent = {
  slug: FASMINAS_PARTNER_SLUG,
  name: "FASMINAS",
  fullName:
    "Federação dos Agentes e Servidores Públicos Municipais de Minas Gerais",
  tagline: "Representatividade sindical dos servidores públicos municipais",
  websiteUrl: "https://fasminas.com.br/",
  logoPath: FASMINAS_LOGO_PATH,
  /** Legado / referência externa; LP usa `logoPath` local. */
  logoUrl: "https://fasminas.com.br/assets/img/logo.png",
  affiliatedUnionsPageUrl: "https://fasminas.com.br/sindicatos-filiados",
  benefitHeadline: "Benefício para filiados",
  heroHeadline:
    "Filiados da FASMINAS e sindicatos associados têm desconto extra na energia",
  heroSubtitle: "Energia solar por assinatura, sem obra e sem investimento inicial.",
  partnershipIntro:
    "A FASMINAS reúne sindicatos de servidores públicos municipais em Minas Gerais. Filiados e sindicatos associados têm desconto extra na energia por assinatura — cadastro simples, benefício automático.",
  affiliatedUnions: [
    {
      id: "sindacs-ace",
      acronym: "SINDACS-ACE",
      name: "Sindicato dos Agentes Comunitários de Saúde e Combate às Endemias de Unaí-MG e região",
      region: "Unaí e região · MG",
      logoUrl: null,
    },
    {
      id: "sintrasp",
      acronym: "SINTRASP",
      name: "Sindicato dos Trabalhadores no Serviço Público Municipal de Uberlândia/MG",
      region: "Uberlândia · MG",
      logoUrl: null,
    },
    {
      id: "sindserp",
      acronym: "SINDSERP",
      name: "Sindicato dos Servidores Públicos Municipais e Autarquias de Ponte Nova – MG",
      region: "Ponte Nova · MG",
      logoUrl: null,
    },
    {
      id: "sismant",
      acronym: "SISMANT",
      name: "Sindicato dos Servidores Públicos Municipais da Região da Mantiqueira",
      region: "Mantiqueira · MG",
      logoUrl: null,
    },
    {
      id: "sindipublicos",
      acronym: "SINDIPÚBLICOS",
      name: "Sindicato dos Servidores Públicos Municipais de Oliveira/MG",
      region: "Oliveira · MG",
      logoUrl: null,
    },
    {
      id: "santana-jacare",
      acronym: "SSPM-SJ",
      name: "Sindicato dos Servidores Públicos Municipais de Santana do Jacaré",
      region: "Santana do Jacaré · MG",
      logoUrl: null,
    },
    {
      id: "sinserves",
      acronym: "SINSERVES",
      name: "Sindicato dos Servidores Públicos Municipais de Esmeraldas-MG",
      region: "Esmeraldas · MG",
      logoUrl: null,
    },
  ] satisfies FasminasAffiliatedUnion[],
} as const
